import React, { useState } from "react";
import styled from "styled-components";

export default function Input({
  name,
  type,
  onChange,
  placeholder,
  defaultValue,
}) {
  const [readOnly, setReadOnly] = useState(true);

  return (
    <AppInputStyle>
      <div>
        <input
          readOnly={readOnly}
          onFocus={() => setReadOnly(false)}
          onBlur={() => setReadOnly(true)}
          autocomplete="off"
          type={type}
          name={name}
          onChange={onChange}
          required
          defaultValue={defaultValue}
          placeholder={placeholder}
        />
      </div>
    </AppInputStyle>
  );
}
const AppInputStyle = styled.div`
  width: 100%;
  outline: none;
  border-radius: 8px;
  background-color: white;
  padding: 0;
  margin-bottom: 20px;

  input {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 6px;
    outline: none;
    border: none;
    background: none;
    padding: 25px 20px;
    font-size: 16px;
  }
  input::placeholder {
    color: #516b91;
  }
`;
